<script setup lang="ts">
defineProps({
  userHasDocument: {
    type: Boolean,
    required: true,
  },
});

const modelValue = defineModel<string>('modelValue', {
  default: '',
});
</script>

<template>
  <template v-if="!userHasDocument">
    <div :class="$style.inputDocument">
      <BaseFormInputCurp
        v-model="modelValue"
        compact
        name="curp"
        :placeholder="$t('auth.register.curp')"
        required
      />
    </div>
  </template>
</template>

<style module lang="postcss">
.inputDocument {
  @apply relative z-10 bg-auth-bg-inputs py-1 rounded-md;
}
</style>
